import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import UpdateIcon from "../../../components/shared/icon/UpdateIcon";
import DeleteIcon from "../../../components/shared/icon/DeleteIcon";
import useAppGlobal from "../../../context/useAppGlobal";
import ConfirmComp from "../../../components/shared/ConfirmComp";
import useManufacturerRemove from "../../../hooks/manufacturer/useManufacturerRemove";
import { enqueueSnackbar } from "notistack";
import ManufactureCreate from "../ManufactureCreate";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function useManufacturerAction() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [manuId, setManuId] = useState();
  const { trigger: removeManu } = useManufacturerRemove(manuId);
  const handleRemoveManu = async (item) => {
    const res = await removeManu({
      id: item?._id,
    });

    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const handleManuUpdate = (item) => {
    handleOpenDialog({
      content: <ManufactureCreate item={item} />,
      size: "md",
      title: "Cập nhật nhà sản xuất",
    });
  };

  const action = [
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleManuUpdate(item),
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.UPDATE_MANUFACTURER]),
    },
    {
      id: uuid(),
      icon: <DeleteIcon />,
      onClick: (item) => {
        setManuId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.name}
              onConfirm={() => handleRemoveManu(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.DELETE_MANUFACTURER]),
    },
  ];
  return action;
}
